export const API_URL = process.env.REACT_APP_API_BASE_URL;
export const API_TOKEN = process.env.REACT_APP_API_TOKEN;
export const VITE_AZURE_CLIENTID = process.env.REACT_APP_VITE_AZURE_CLIENTID;
export const VITE_AZURE_AUTHORITY = process.env.REACT_APP_VITE_AZURE_AUTHORITY;
export const PIMS_BASE_URL = process.env.REACT_APP_PIMS_BASE_URL;
export const PIMS_X_API_KEY = process.env.REACT_APP_PIMS_X_API_KEY;

